import { PartnerSection } from 'features/podcasts/components/PartnerSection/PartnerSection.component';
import React, { ComponentPropsWithRef, FC, useMemo } from 'react';
import { BreadCrumbStep } from '@components/BreadCrumb/BreadCrumb.types';
import { PrimaryButton } from '@components/buttons/FlatButton/FlatButton.component';
import { Text } from '@components/Text/Text.component';
import { DeezerLogoIcon } from '@icons/podcasts/DeezerLogo.icon';
import { SpotifyLogoIcon } from '@icons/podcasts/SpotifyLogo.icon';
import { PlcAnchor } from '@layout/components/PlcAnchor/PlcAnchor.component';
import { PlcPageHeader } from '@layout/components/PlcPageHeader/PlcPageHeader.component';
import { PlcPageLayout } from '@layout/components/PlcPageLayout/PlcPageLayout.component';
import { Constants } from '@utils/Constants';
import { urlEnum } from '@utils/url';
import { ATLevel2, PlcTagProps } from 'features/tagPlan/business/TagPlan.types';
import styles from './PodcastsLayout.module.scss';

type Props = ComponentPropsWithRef<'main'>;
const ICON_HEIGHT = 30;

const PodcastsLayout: FC<Props> = ({ ...rest }) => {
  const TAG_PROPS: PlcTagProps = useMemo(
    () => ({
      level2: ATLevel2.Podcasts,
      tagPageNameI18nArray: ['common.podcasts'],
    }),
    []
  );

  const BREADCRUMB_STEPS: BreadCrumbStep[] = [
    {
      label: 'common.newspaper-short',
      linkProps: { as: urlEnum.home, href: urlEnum.home },
    },
    {
      label: 'common.podcasts',
      linkProps: { as: urlEnum.podcasts, href: urlEnum.podcasts },
    },
  ];

  return (
    <PlcPageLayout className={styles.podcastsPage} metaTitleI18n="podcasts.page.title" tagProps={TAG_PROPS} {...rest}>
      <PlcPageHeader
        breadCrumbSpacing="plc-mb-m"
        breadcrumbSteps={BREADCRUMB_STEPS}
        withBlockAd={false}
        withMegaBannerAd={false}
      />

      <section className="wrapper-s">
        <Text className="plc-my-m" i18nKey="podcasts.seo" id="podcasts-text-seo" tag="div" variant="new-p" />
        <div className={styles.playerSlot} />
        <div className={styles.buttons}>
          <PlcAnchor linkProps={{ href: Constants.PODCASTS.DEEZER_URL }} target="_blank">
            <PrimaryButton isWithGreyBorder isWithIcon>
              <DeezerLogoIcon height={ICON_HEIGHT} />
            </PrimaryButton>
          </PlcAnchor>
          <PlcAnchor linkProps={{ href: Constants.PODCASTS.SPOTIFY_URL }} target="_blank">
            <PrimaryButton isWithGreyBorder isWithIcon>
              <SpotifyLogoIcon height={ICON_HEIGHT} />
            </PrimaryButton>
          </PlcAnchor>
        </div>
      </section>

      <PartnerSection />
    </PlcPageLayout>
  );
};

export { PodcastsLayout };
